import api from "@/api/attestation";

export default {
  state: {
    attestationsList: null,
    attestation: null,
    attestation_blocks:null,
    current_block: null,
    result: null,
    isResult: null,
    errorsCount: null,
    attempts: null,
    attemptsMax: 2,
    view_settings: null,
    attestation_time_left: null
  },
  getters: {
    getAttestationsList: state => state?.attestationsList,
    getAttestationFromList: state => (id) => state?.attestationsList && state.attestationsList[id],
    getActiveAttestationTestInfo: state => state?.attestation,
    // getBlocks: (state) => {
    //   let attestation_blocks = state?.attestation_blocks;
    //   if (attestation_blocks && attestation_blocks.length) {
    //     attestation_blocks.sort((a, b) => { return a.sort - b.sort; });
    //   }
    //   return attestation_blocks;
    // },
    getBlocks: (state) => state?.attestation_blocks,
    getAttestationId: (state) => state?.attestation?.id,
    getAttestationAttempt: (state) => state?.attestation?.attempt,
    getAttestationMaxAttempts: (state) => state?.attestation?.attempts,
    getTestViewSettings: (state) => state?.attestation?.view_settings,
    getCurrentBlock: (state) => state?.current_block,
    getAttestationTimeLeft: (state) => state?.attestation_time_left,
  },
  mutations: {
    SET_ATTESTATIONS(state, payload) {
      state.attestationsList = payload;
    },
    SET_ACTIVE_ATTESTATION(state, payload) {
      state.attestation = payload;
    },
    SET_ATTESTATION_BLOCKS(state, payload) {
      state.attestation_blocks = payload;
    },
    SET_CURRENT_BLOCK(state, payload) {
      state.current_block = payload;
    },
    SET_ATTESTATION_TIME_LEFT(state, payload) {
      state.attestation_time_left = payload;
    },
    CLEAR_ATTESTATION_RESULTS(state) {
      state.result = null;
      state.isResult = false;
      state.errorsCount = null;
      state.current_block = null;
      state.attestation = null;
      state.attestation_time_left = null;
      state.attestation_blocks = null;
    }
  },
  actions: {
    async fetchAttestationsList({commit }) {
      try {
        const response = await api.getAttestation();
        const {
          data: {
            data: {
              attestations
            }
          },
          status
        } = response;

        if (status === 200) {
          commit("SET_ATTESTATIONS", attestations);
        }
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async getAttestationData({ commit }, id) {
      try {
        const response = await api.getAttestationById(id);
        const {
          data: {
            data: {
              attestation,
              attestation_time_left
            }
          },
          status
        } = response;

        if (status === 200) {
          commit("SET_ACTIVE_ATTESTATION", attestation);
          commit("SET_ATTESTATION_TIME_LEFT", attestation_time_left)
        }
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async fetchAttestationTestById({ commit }, id) {
      try {
        const response = await api.getAttestationTestById(id);
        const {
          data: {
            data: {
              attestation,
              attestation_blocks,
              current_block,
              attestation_time_left
            }
          },
          status
        } = response;

        if (status === 200) {
          commit("SET_ACTIVE_ATTESTATION", attestation);
          commit("SET_ATTESTATION_BLOCKS", attestation_blocks);
          commit("SET_CURRENT_BLOCK", current_block);
          commit("SET_ATTESTATION_TIME_LEFT", attestation_time_left)
        }
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    postAttestationTest({ commit, dispatch }, payload) {
      dispatch("setIsLoadingData", true);
      api.saveAttestationTest(payload)
        .then(
          ({
             data: {
               data: {
                 answers: { results, errors_count }
               }
             }
           }) => {
            commit("SET_TEST_RESULTS", results);
            commit("SET_TEST_ERRORS_COUNT", errors_count);
          }
        )
        .finally(() => {
          dispatch("setIsLoadingData", false);
        });
    },
    clearAttestationResultsData({ commit }) {
      commit("CLEAR_ATTESTATION_RESULTS");
    },
    getAttestationBlock({ commit, dispatch }, payload) {
      dispatch("setIsLoadingData", true);
      api.getAttestationBlock(payload)
          .then(
            ({
               data: {
                 data: {
                   current_block,
                   attestation_time_left
                 }
               }
             }) => {
              commit("SET_CURRENT_BLOCK", current_block);
              commit("SET_ATTESTATION_TIME_LEFT", attestation_time_left)
            }
          )
          .finally(() => {
            dispatch("setIsLoadingData", false);
          })
    },
    // async getAttestationBlock({ commit, dispatch }, payload) {
    //   try {
    //     const response = await api.getAttestationBlock(payload);
    //     const {
    //       data: {
    //         data: {
    //           current_block
    //         }
    //       },
    //       status
    //     } = response;
    //
    //     if (status === 200) {
    //       commit("SET_CURRENT_BLOCK", current_block);
    //     }
    //     return Promise.resolve();
    //   } catch (error) {
    //     return Promise.reject(error);
    //   }
    // },
  }
};